
import { defineComponent, SetupContext, computed, PropType } from 'vue'
import { useStore } from 'vuex'
import Button from '@/components/elements/Button.vue'
import HospitalLabel from '@/components/elements/HospitalLabel.vue'
import HospitalTag from '@/components/elements/HospitalTag.vue'

export default defineComponent({
  name: 'HospitalCassetteOnlineEvent',

  props: {
    detail: {
      type: Object,
      default: () => ({})
    },
    title: {
      type: String,
      default: ''
    },
    label: {
      type: Array as PropType<string[]>,
      default: []
    },
    channelName: {
      type: String,
      required: true
    },
    channelDescription: {
      type: String,
      required: true
    },
    liveStatus: {
      type: String as PropType<'live' | 'soon' | 'before' | 'after'>,
      required: true
    },
    programStartTime: {
      type: String,
      required: true
    },
    hospitalStart: {
      type: String,
      required: true
    },
    hospitalEnd: {
      type: String,
      required: true
    },
    enableRequest: {
      type: Boolean,
      default: false
    },
    viewLive: {
      type: Function as PropType<
        (
          channelName: string,
          selectedProgramStart: string,
          btnType?: string
        ) => void
      >,
      required: true
    }
  },

  components: {
    Button,
    HospitalLabel,
    HospitalTag
  },

  setup(props, context: SetupContext) {
    const store = useStore()

    const features = props.detail.discerning_conditions
      ? props.detail.discerning_conditions.map((el: string) => {
          return {
            label: el,
            disabled: false
          }
        })
      : []

    const btnLabel = computed((): string => {
      if (props.liveStatus === 'before')
        return props.programStartTime + '配信予定'
      if (['soon', 'live'].includes(props.liveStatus)) return '配信内容を見る'
      if (props.liveStatus === 'after') return '配信終了'
      return '配信終了'
    })

    const thumbLabel = computed((): string => {
      if (props.liveStatus === 'before')
        return props.programStartTime + '配信予定'
      if (['soon', 'live'].includes(props.liveStatus)) return '配信内容を見る'
      if (props.liveStatus === 'after') return '配信終了'
      return '配信終了'
    })

    const isFavorite = computed((): boolean => {
      if (store.state.isLogin) {
        const favoriteIds = store.state.userInfo.favorite_history.map(
          (el: Record<'id' | 'hospital_id', number>) => {
            return el.hospital_id
          }
        )
        return favoriteIds.includes(props.detail.hospital_id)
      }
      return false
    })

    const favBtnLabel = computed((): string => {
      return isFavorite.value ? '登録済み' : '未登録'
    })

    const canRequestCheck = computed((): boolean => {
      return (
        props.enableRequest &&
        props.detail.paid_flg === 1 &&
        props.detail.active_flg === 3
      )
    })

    const changeInput = (e: any) => {
      context.emit('call-input-change', {
        value: e.target.value,
        checked: e.target.checked
      })
    }

    const casseteTitle = computed((): string => {
      const number = 30
      const ttl = props.channelDescription
        ? props.channelDescription
        : props.title
      return ttl.length > number ? ttl.substr(0, number) + '…' : ttl
    })

    return {
      features,
      btnLabel,
      thumbLabel,
      isFavorite,
      favBtnLabel,
      canRequestCheck,
      changeInput,
      casseteTitle
    }
  }
})
